import styled from 'styled-components';

const Filter = styled.div`
  margin-bottom: 20px;
  border: 1px solid gray;
  border-radius: 5px;
  width: 360px;
  padding: 12px;
  p {
    margin-bottom: 10px;
  }
`;

const css = {
  Filter,
};

export default css;
